<script lang="ts">
  import ProductHelpers from "@shared/svelte/ProductHelpers";

  import ContainerDepositInfo from "@retailer/svelte/Cart/Page/DistributorSection/ContainerDepositInfo.svelte";
  import CarrierDepositInfo from "@retailer/svelte/Cart/Page/DistributorSection/CarrierDepositInfo.svelte";

  import type { CartProduct } from "@shared/types/ProductLine";

  export let cartProduct: CartProduct;

  let productId = cartProduct.id;
  let containerCount = ProductHelpers.orderProductUnitCount(cartProduct);
  let includedInPrice = cartProduct.deposit_included_in_price;

</script>

<ContainerDepositInfo
  {productId}
  {containerCount}
  {includedInPrice}
  containerType={cartProduct.product.container_type}
  containerDeposit={cartProduct.container_deposit}
/>

<CarrierDepositInfo {productId} carrierDeposit={cartProduct.carrier_deposit} />
